import type { ProFieldValueEnumType } from '@ant-design/pro-components';

export enum YesNoStatus {
  Enabled = 1,
  Disabled = 2,
}

export const YES_NO_STATUS_ENUM: ProFieldValueEnumType = {
  [YesNoStatus.Enabled]: { text: '启用', status: 'Success' },
  [YesNoStatus.Disabled]: { text: '停用', status: 'Default' },
};

export const YES_NO_STATUS_OPTIONS = [
  { label: '启用', value: YesNoStatus.Enabled },
  { label: '停用', value: YesNoStatus.Disabled },
];
